import React from 'react'
import { TrackingContainer } from '@mc/visibility'
import { FaqWrapper } from './components/FaqWrapper'
import { trackClick, trackViewed, type TrackingProps } from './events'
import type { Section } from './types'

type Props = {
  mainTitle: string
  data: Section[]
  trackingProps: TrackingProps
  className?: string
  appearance?: {
    shouldShowLargeHeader?: boolean
  }
}

export const FAQ = ({
  className = '',
  mainTitle,
  data,
  trackingProps,
  appearance = { shouldShowLargeHeader: false },
  ...props
}: Props) => {
  const trackFaqClick = (expandedIds: Array<string | number>) => {
    const [question] = expandedIds ?? []
    trackClick({ question: question?.toString() ?? '', ...trackingProps })
  }

  return (
    <TrackingContainer
      config={{ threshold: 0.3 }}
      onFirstVisible={() => trackViewed(trackingProps)}
      className={className}
    >
      <FaqWrapper
        onFaqClick={trackFaqClick}
        faqData={data}
        shouldShowLargeHeader={appearance.shouldShowLargeHeader}
        mainTitle={mainTitle}
        {...props}
      />
    </TrackingContainer>
  )
}
